import { Page } from "@boundary/layouts/pageLayout";
import { Button } from "@boundary/components/button";
import { OnboardingElement } from "@boundary/widgets/onboarding";
import { OnboardingFlowData, OnboardingFlowSteps } from "@boundary/pages/4.onboarding/onboardingFlow";
import { Stepper } from "@boundary/components/stepper";
import styles from "./pickup.module.scss";

export const OnboardingPickupStep: OnboardingElement<
  OnboardingFlowData,
  OnboardingFlowSteps
> = (props) => {
  return (
    <Page withFog>
      <Page.SafeArea />
      <Page.DisplayZone>
        <Page.DisplayZone.Body className={styles.body}>
          <Stepper count={3} current={3} />
          <h1>Как получить заказ?</h1>
          <p>
            Когда заказ будет готов, подойди к аппарату и открой ячейку прямо из
            приложения — проведи пальцем по кнопке «Открыть ячейку» на экране заказа.
          </p>
        </Page.DisplayZone.Body>
        <Page.DisplayZone.Sticky className={styles.buttonPad}>
          <Button onClick={() => props.onComplete(null)}>Начать пользоваться!</Button>
        </Page.DisplayZone.Sticky>
      </Page.DisplayZone>
    </Page>
  );
};
